module.exports = __webpack_public_path__ + "img/136.0620e99.svg";